import React from "react";
import { Box, EmptyJouvie } from "app/components/common";
import i18n from "@microdoing/shared/i18n";
import { useSelector } from "react-redux";
import { getHasCoachingResources } from "@microdoing/shared/services/coaching/selectors";
import { ResourceTabs } from "../../navigation";
import { getHasCampaignResources } from "@microdoing/shared/services/resources/selectors";
import CampaignResources from "./CampaignResources";
import CoachResources from "./CoachResources";
import theme from "app/Theme/Theme";
import HeaderScreen from "app/components/common/HeaderScreen";
import { SafeAreaView } from "react-native-safe-area-context";

const Library = ({ navigation }) => {
  const hasCampaignResources = useSelector(getHasCampaignResources);
  const hasCoachingResources = useSelector(getHasCoachingResources);

  return (
    <SafeAreaView style={{ flex: 1 }} edges={["top"]}>
      <Box flex={1} variant="screenView" testID="resources-screen">
        <HeaderScreen leftIcon title={i18n.t("resources")} />

        {!hasCampaignResources && !hasCoachingResources && (
          <EmptyJouvie
            onPress={() => navigation.navigate("Home")}
            firstMessage={i18n.t("no-resources")}
            secondMessage={i18n.t("go-challenges")}
          />
        )}
        {hasCampaignResources && hasCoachingResources ? (
          <ResourceTabs
            hasCampaignResources={hasCampaignResources}
            hasCoachingResources={hasCoachingResources}
          />
        ) : (
          <Box flex={1}>
            {hasCampaignResources && <CampaignResources />}
            {hasCoachingResources && <CoachResources />}
          </Box>
        )}
      </Box>
    </SafeAreaView>
  );
};

export default Library;
